import * as yup from 'yup'

export const FORMIK_VALUE = {
  ORIGINAL_PASSWORD: 'Original_Password',
  NEW_PASSWORD: 'New_Password',
  CONFIRM_PASSWORD: 'Confirm_Password'
}

export const VALIDATION_SCHEMA = yup.object({
  [FORMIK_VALUE.ORIGINAL_PASSWORD]: yup.string().required('This field is required'),
  [FORMIK_VALUE.NEW_PASSWORD]: yup.string().required('This field is required').min(8, 'New password must contain at least 8 characters'),
  [FORMIK_VALUE.CONFIRM_PASSWORD]: yup.string().required('This field is required').min(8, 'Confirm password must contain at least 8 characters')
    .test('passwords-match', 'Passwords must match', function (value) {
      return value === this.parent[FORMIK_VALUE.NEW_PASSWORD]
    })
})
